import { render, staticRenderFns } from "./DocumentDetailList33.vue?vue&type=template&id=d34904c6&scoped=true"
import script from "./DocumentDetailList33.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList33.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34904c6",
  null
  
)

export default component.exports